import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    padding: theme.spacing(2.25, 1.5),
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.Dela.mainBackground,
    color: theme.palette.primary.main
  },
  root2: {
    display: 'flex',
    flexWrap: 'nowrap',
    padding: theme.spacing(1, 3),
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    color: theme.palette.common.black,
    minHeight: theme.spacing(6)
  },
  container: {
    display: 'flex'
  },
  buttons: {
    display: 'flex',
    margin: theme.spacing(0, 3),
    columnGap: theme.spacing(2)
  }
}));

export default useStyles;
